import Payments from "./Container"

export default Payments
